import { Form, Input, Modal, Select } from "antd";
import PropTypes from "prop-types";
import { useEffect } from "react";

const expertTypeOptions = [
  "EXPERT MÉDICAL",
  "EXPERT MÉCANIQUE",
  "EXPERT JUDICIAIRE",
  "INVESTIGATEUR",
  "MEDECIN CONSEIL"
];

const AddExpert = ({ open, loading, onCancel, onSubmit, expert }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      if (expert) {
        form.setFieldsValue({
          nom: expert?.nom || "",
          prenom: expert?.prenom || "",
          adresse: expert?.adresse || "",
          profession: expert?.profession || "",
          email: expert?.email || "",
          telephone: expert?.contact?.[0] || "",
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, expert, form]);

  const handleFinish = (values) => {
    onSubmit?.(values);
  };

  return (
    <Modal
      open={open}
      title={expert ? "Modifier un expert" : "Ajouter un expert"}
      okText={expert ? "Mettre à jour" : "Enregistrer"}
      cancelText="Annuler"
      onCancel={onCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        <Form.Item
          label="Nom"
          name="nom"
          rules={[{ required: true, message: "Veuillez renseigner le nom" }]}
        >
          <Input placeholder="Nom de l'expert" />
        </Form.Item>

        <Form.Item
          label="Prénom(s)"
          name="prenom"
          rules={[{ required: true, message: "Veuillez renseigner les prénoms" }]}
        >
          <Input placeholder="Prénom(s) de l'expert" />
        </Form.Item>

        <Form.Item
          label="Adresse"
          name="adresse"
          rules={[{ required: true, message: "Veuillez renseigner l'adresse" }]}
        >
          <Input placeholder="Adresse de l'expert" />
        </Form.Item>

        <Form.Item
          label="Type d'expert"
          name="profession"
          rules={[{ required: true, message: "Veuillez sélectionner le type d'expert" }]}
        >
          <Select
            placeholder="Sélectionnez le type d'expert"
            options={expertTypeOptions.map((value) => ({ value, label: value }))}
            allowClear
          />
        </Form.Item>

        <Form.Item label="Email" name="email" rules={[{ type: "email", message: "Adresse email invalide" }]}
        >
          <Input placeholder="Adresse email" />
        </Form.Item>

        <Form.Item
          label="Téléphone"
          name="telephone"
          rules={[{ required: true, message: "Veuillez renseigner le numéro de téléphone" }]}
        >
          <Input placeholder="Numéro de téléphone" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddExpert.propTypes = {
  open: PropTypes.bool,
  loading: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  expert: PropTypes.object,
};

export default AddExpert;
